import { DropdownOptions } from '../../Components/dropdownOptions';

export const dataToOptionsTransformer = ({
  dataToTransform,
  value,
  text,
}: {
  dataToTransform: Array<any>;
  value: string;
  text: string;
}): Array<DropdownOptions> =>
  (dataToTransform || []).map(
    (data: any): DropdownOptions => ({
      value: data[value],
      text: data[text],
    })
  );
